var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBracketsSquare = function SvgIconBracketsSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2.75a1 1 0 0 0-1 1v16.5a1 1 0 0 0 1 1H7.5a1 1 0 1 0 0-2H4.75V4.75H7.5a1 1 0 0 0 0-2zM16.5 2.75a1 1 0 1 0 0 2h2.75v14.5H16.5a1 1 0 1 0 0 2h3.75a1 1 0 0 0 1-1V3.75a1 1 0 0 0-1-1z"
  }))));
};
export default SvgIconBracketsSquare;